module.exports = __webpack_public_path__ + "img/tank_fractions.b0c6e43.svg";